export default __webpack_public_path__ + "static/media/codeEditor.5ca43a63.png";